import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { PimoReactComponent } from "@pimo/pimo-app-builder";
import { TableUpdateStatusCell } from "@pimo/pimo-components";
import { BffOe, OeKpis } from "aint-types";
import { formatDate } from "aint-utils";

import { theme } from "../../app/theme";
import OeKpisDataGrid from "../oe-kpis-data-grid/oe-kpis-data-grid";

export type EditOeKpisDialogProps = {
  title: string;
  open: boolean;
  operatingEntity?: BffOe;
};

export type EditOeKpisDialogEventTypes = "popup:close" | "popup:save";

export type EditOeKpisDialogEventPayload = OeKpis | undefined;

export const EditOeKpisDialog: PimoReactComponent<
  EditOeKpisDialogProps,
  EditOeKpisDialogEventTypes,
  EditOeKpisDialogEventPayload
> = ({ open, title, operatingEntity, fireEvent }) => {
  const { lastUpdatedKpis } = operatingEntity ?? {};

  const handleClose = () => {
    fireEvent?.("popup:close");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      sx={{ boxShadow: "none", zIndex: 10000 }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "none",
          zIndex: 10000,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            boxShadow: "none",
          },
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center" gap={4}>
          <Typography fontSize="20px" fontWeight={500} lineHeight="24px">
            {title ?? ""}
          </Typography>
          {lastUpdatedKpis && (
            <TableUpdateStatusCell
              chipColor="#00378120"
              cardProps={{
                sx: {
                  div: {
                    div: {
                      lineHeight: "initial",
                      height: "initial",
                    },
                  },
                },
              }}
              chipProps={{
                sx: {
                  fontWeight: 500,
                  fontSize: "12px",
                },
              }}
              body={`Last updated: ${formatDate(lastUpdatedKpis, "YYYY/MM/DD")}`}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <IconButton
            sx={{
              "@media print": {
                display: "none",
              },
            }}
            onClick={handleClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider
        sx={{
          bgcolor: theme.palette.secondary.main,
          height: "1px",
          borderWidth: 0,
        }}
      />
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          border: "none",
          color: theme.palette.primary.contrastText,
          padding: "20px 24px 0 24px",
        }}
      >
        <OeKpisDataGrid
          editable
          operatingEntity={operatingEntity}
          fireEvent={fireEvent}
        />
        <Typography
          sx={{
            marginTop: "8px",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15px",
          }}
        ></Typography>
      </DialogContent>
    </Dialog>
  );
};
